import "yet-another-react-lightbox/styles.css";
import Lightbox from "yet-another-react-lightbox";
import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Gallery from "../../components/Gallery/Gallery";
import { images } from "../../assets/images";
import Footer from "../../components/Footer/Footer";
// Uncomment the following import to use the video in assets
// import videoBg from "../../assets/HMR_vid.mp4";

const videoBg = "/gallery/HMR_vid.mp4";
const videoPoster = "/gallery/HMR_vid-poster.jpg";

const Home = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [isVideoPlaying, setIsVideoPlaying] = useState(false);

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkScreenSize(); // Initial check
        window.addEventListener('resize', checkScreenSize);

        return () => window.removeEventListener('resize', checkScreenSize);
    }, []);

    const slides = images.map(({ src, width, height }) => ({
        src: src,
        width,
        height,
    }));
        
    const [visibleItems, setVisibleItems] = useState(12);
    
    const loadMore = () => {
        setVisibleItems((prevVisibleItems) => prevVisibleItems + 12);
    };

    const [index, setIndex] = useState(-1);

    const handleClick = (index, item) => setIndex(index);

    const handlePlayVideo = () => {
        const video = document.getElementById("video-bg");
        video.play();
        setIsVideoPlaying(true);
    };

    return (
        <main className="flex flex-1 flex-col">
            <Navbar/>
            <section className="mx-auto flex w-full max-w-7xl flex-col items-center gap-10 px-4 py-10 shadow-sm sm:px-8 lg:flex-row lg:justify-center lg:gap-16 lg:py-14">
                <div className="flex max-w-xl flex-col items-center text-center lg:w-1/2">
                    <h1 className="text-3xl font-bold text-neutral-800 md:text-4xl lg:text-5xl">Welcome to HMR Decor</h1>
                    <span className="my-6 h-0.5 w-16 bg-gold" aria-hidden="true"></span>
                    <p className="text-lg font-medium leading-relaxed text-neutral-700 md:text-xl">Transform your dream wedding into reality with HMR Decor! Now accepting bookings for 2025 in the GTA.</p>
                    <p className="mt-4 text-base leading-relaxed text-neutral-600 md:text-lg">Our affordable and customizable decor packages ensure your special day is as unique as your love story. From classic elegance to modern chic, we’ve got you covered. Say “i do” to unforgettable moments and stress-free planning. Book now and let the magic begin!</p>
                </div>
                <div className="relative w-full max-w-sm lg:w-auto">
                    <video 
                        id="video-bg" 
                        className="max-h-[60vh] w-full object-cover lg:h-[60vh] lg:w-auto" 
                        src={videoBg} 
                        poster={videoPoster}
                        preload={isMobile ? "none" : "auto"}
                        autoPlay={!isMobile}
                        loop 
                        muted 
                        playsInline
                        onPlay={() => setIsVideoPlaying(true)}
                    />
                    {isMobile && !isVideoPlaying && (
                        <button className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-md bg-black/50 px-5 py-2.5 text-2xl text-white hover:bg-black/70" onClick={handlePlayVideo}>
                            Play Video
                        </button>
                    )}
                </div>
            </section>
            <section className="mx-auto w-full px-4 text-center sm:px-8 lg:w-4/5 lg:px-0">
                <h1 className="mt-10 text-3xl font-bold text-neutral-800 md:text-4xl">Crafting Moments, Creating Memories.</h1>
                <div className="mt-10">
                    <Gallery
                        onClick={handleClick}
                        images={images.slice(0, visibleItems)}
                    />
                    {visibleItems < images.length && (
                        <button onClick={loadMore} className="btn-dark">
                            Load More
                        </button>
                    )}
                </div>
            </section>
            <Lightbox
                index={index}
                open={index >= 0}
                close={() => setIndex(-1)}
                slides={slides}
            />
            <Footer/>
        </main>
    );
}

export default Home;
